// extracted by mini-css-extract-plugin
export default {"input":"phonenumber_input__uqxSF","formGroup":"phonenumber_formGroup__5iQoi"};